import { ChangeDetectionStrategy, Component, ElementRef, viewChild } from '@angular/core';
// import { setInterval as wSetInterval, clearInterval as wClearInterval } from 'worker-timers';
import { SelectCameraInputButtonComponent } from '../../shared/new-slick/select-camera-input-button/select-camera-input-button.component';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-screenshare',
  imports: [MatTabsModule, SelectCameraInputButtonComponent],
  templateUrl: './screenshare.component.html',
  styleUrls: ['./screenshare.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ScreenshareComponent {
  readonly cameraVideo = viewChild.required<ElementRef<HTMLVideoElement>>('camera');
  readonly screenVideo = viewChild<ElementRef<HTMLVideoElement>>('screen');
  readonly remoteVideo = viewChild.required<ElementRef<HTMLVideoElement>>('remote');

  cameraStream = null as MediaStream;
  screenStream = null as MediaStream;
  localPeer = null as RTCPeerConnection;
  remotePeer = null as RTCPeerConnection;
  worker = null as Worker;

  cameraDeviceId: string = '';
  isStart = false;

  mixAudioStreams(streams) {
    const audioContext = new AudioContext();
    const gainNode = audioContext.createGain();
    const audioDestination = audioContext.createMediaStreamDestination();
    gainNode.connect(audioContext.destination);
    gainNode.gain.value = 0;
    streams.forEach((stream) => {
      const audioSource = audioContext.createMediaStreamSource(stream);
      audioSource.connect(gainNode);
      audioSource.connect(audioDestination);
    });

    return audioDestination.stream;
  }

  async start() {
    if (!('MediaStreamTrackProcessor' in window)) {
      alert('Cannot find MediaStreamTrackProcessor. Enable experimental features');
      return;
    }
    console.log('H1');

    const constraints: MediaStreamConstraints = {
      audio: true,
      video: {
        deviceId: this.cameraDeviceId,
        width: 640,
        height: 360,
      },
    };

    // get camera stream
    this.cameraStream = await navigator.mediaDevices.getUserMedia(constraints);

    const [cameraTrack] = this.cameraStream.getVideoTracks();
    const { readable: cameraReadableStream } = new MediaStreamTrackProcessor({ track: cameraTrack });
    this.cameraVideo().nativeElement.srcObject = this.cameraStream;

    // get screen stream
    this.screenStream = await navigator.mediaDevices.getDisplayMedia({ audio: true, video: true });
    const [screenTrack] = this.screenStream.getVideoTracks();
    const { readable: screenReadableStream } = new MediaStreamTrackProcessor({ track: screenTrack });
    this.screenVideo().nativeElement.srcObject = this.screenStream;

    // create a generator
    const composedTrackGenerator = new MediaStreamTrackGenerator({ kind: 'video' });
    const sink = composedTrackGenerator.writable;

    let audioTrack;
    // mix audio streams if screen has one
    if (this.screenStream.getAudioTracks().length > 0) {
      const mixedAudioStream = this.mixAudioStreams([this.cameraStream, this.screenStream]);
      audioTrack = mixedAudioStream.getAudioTracks()[0];
    } else {
      audioTrack = this.cameraStream.getAudioTracks()[0];
    }

    const composedStream = new MediaStream();
    composedStream.addTrack(composedTrackGenerator);
    composedStream.addTrack(audioTrack);

    this.remoteVideo().nativeElement.srcObject = composedStream;
    //this.remoteVideo().nativeElement.play();
    this.isStart = true;
  }

  stop() {
    this.isStart = false;

    this.worker.postMessage({
      operation: 'stop',
    });
    if (this.remotePeer) {
      this.remotePeer.close();
    }
    if (this.localPeer) {
      this.localPeer.close();
    }
    if (this.cameraStream) {
      this.cameraStream.getTracks().forEach(function (track) {
        track.stop();
      });
    }
    if (this.screenStream) {
      this.screenStream.getTracks().forEach(function (track) {
        track.stop();
      });
    }
    if (this.worker) {
      this.worker.terminate();
    }
  }

  async updateDeviceId(device: MediaDeviceInfo) {
    this.cameraDeviceId = device.deviceId;
  }
}
